import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import WalletModal from '../WalletModal';
import sentenceSeparator from '../../../utils/sentenceSeparator';
import lockIcon from '../../../img/icons/lock.svg';
import style from '../../../style/components/profile/emails/WalletLockedModal.module.scss';

// Feather "external-link" glyph, matching the idme-icon web component's
// path data — FragnoButton's icon slots take raw SVG markup, not an icon name.
const EXTERNAL_LINK_ICON =
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>';

const WalletLockedModal = ({ isOpen, onClose, onContactSupport }) => {
  const { t, i18n } = useTranslation();

  return (
    <WalletModal
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        text: t('walletEmails.lockedContactSupport'),
        onClick: onContactSupport,
        iconTrailing: EXTERNAL_LINK_ICON,
      }}
    >
      <img slot="icon" src={lockIcon} alt="" width="16" height="16" />
      <span slot="title">{t('walletEmails.lockedTitle')}</span>
      <div slot="body">
        <p className={style.body}>
          {t('walletEmails.lockedBody')}
          {sentenceSeparator(i18n.language)}
          {t('walletEmails.lockedCta')}
        </p>
      </div>
    </WalletModal>
  );
};

WalletLockedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onContactSupport: PropTypes.func.isRequired,
};

export default memo(WalletLockedModal);
